// SPDX-License-Identifier: EPL-2.0

/**
 * Checks whether a mouse click on a link is the usual "open in a new tab" gesture:
 * Ctrl/Cmd + left click or a middle click.
 *
 * Clicks with Shift or Alt are not treated as such, so the browser keeps handling them
 * (e.g. Ctrl+Shift+click still opens a real browser tab).
 *
 * @public
 */
export function isNewTabClick (e: Pick<MouseEvent, 'button' | 'ctrlKey' | 'metaKey' | 'shiftKey' | 'altKey'>): boolean {
  if (e.shiftKey || e.altKey) return false
  if (e.button === 1) return true
  return e.button === 0 && (e.ctrlKey || e.metaKey)
}
